import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';

import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';

import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { ExpenseType } from '../../../app/models/ExpenseType';
import useExpenseTypeService from '../../../app/services/hooks/useExpenseTypeService';
import ExpenseTypeForm from './forms/ExpenseTypeForm';
import { Account } from '../../../app/models/Account';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ExpenseTypeCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [errorGetData, setErrorGetData] = useState('');
    const [expenseType, setExpenseType] = useState<ExpenseType>({ name: '' });
    const [accounts, setAccounts] = useState<Account[]>([]);

    const [errorFields, setErrorFields] = useState<any>();

    const {
        fetchingStoreExpenseType,
        fetchingCreateExpenseType,
        createExpenseType,
        storeExpenseType
    } = useExpenseTypeService();

    useEffect(() => {
        createExpenseType({
            onSuccess(response: ServiceResponse) {
                setAccounts(response.data.accounts);
            },
            onError(response: ServiceResponse) {
                if (hideLoading) hideLoading();
            }
        });
    }, []);

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando tipo de gasto...');
        storeExpenseType(expenseType, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <ExpenseTypeForm
                        expenseTypeDataForm={expenseType}
                        setExpenseTypeDataForm={setExpenseType}
                        accounts={accounts}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreExpenseType} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreExpenseType} />
                </div>
            </div>
        </>
    );
};

export default ExpenseTypeCreate;
